import * as Yup from 'yup';

const tasklistSchema = Yup.object({
    name:Yup.string().required('INPUT.VALIDATION.CUSTOMER.TASK.NAME'),
    description:Yup.string(),
    type:Yup.string().required('INPUT.VALIDATION.CUSTOMER.TASK.TYPE')
})

export default tasklistSchema;